import React, { useState } from "react";
import { UserPlus, UserCheck } from "lucide-react";
import { followUser, unfollowUser } from "../lib/api";

export default function FollowButton({ userId, initial = false, onChange }) {
  const [following, setFollowing] = useState(initial);
  const [busy, setBusy] = useState(false);

  const toggle = async () => {
    setBusy(true);
    try {
      if (following) {
        await unfollowUser(userId);
        setFollowing(false);
      } else {
        await followUser(userId);
        setFollowing(true);
      }
      onChange && onChange(!following);
    } catch {} finally { setBusy(false); }
  };

  return (
    <button
      data-testid={`follow-btn-${userId}`}
      onClick={toggle}
      disabled={busy}
      className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold"
      style={following
        ? { background: "rgba(255,255,255,0.06)", color: "#fff", border: "1px solid rgba(255,255,255,0.15)" }
        : { background: "linear-gradient(90deg,#00F0FF,#B026FF)", color: "#000", border: "1px solid transparent" }}
    >
      {following ? <><UserCheck className="w-3.5 h-3.5" /> Following</> : <><UserPlus className="w-3.5 h-3.5" /> Follow</>}
    </button>
  );
}
